const childRoutes = (prop) => [
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../pages/dashboard/List.vue')
  },
  {
    path: 'sales-target',
    name: prop + '.sales_target',
    meta: { auth: true },
    component: () => import('../pages/sales-target/List.vue')
  },
  {
    path: 'demand-order-entry',
    name: prop + '.demand_order_entry',
    meta: { auth: true },
    component: () => import('../pages/demand-order-entry/List.vue')
  },
  {
    path: 'demand-order-entry-form',
    name: prop + '.demand_order_entry_form',
    meta: { auth: true },
    component: () => import('../pages/demand-order-entry/Form.vue')
  },
  {
    path: 'delivery-order-receive',
    name: prop + '.delivery_order_receive',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-receive/List.vue')
  },
  {
    path: 'sales-report',
    name: prop + '.sales_report',
    meta: { auth: true },
    component: () => import('../pages/sales-report/List.vue')
  },
  {
    path: 'receive-entry',
    name: prop + '.receive_entry',
    meta: { auth: true },
    component: () => import('../pages/receive-entry/List.vue')
  },
  {
    path: 'delivery-order-receive',
    name: prop + '.delivery_order_receive',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-receive/List.vue')
  },
  {
    path: 'sales-list',
    name: prop + '.sales_list',
    meta: { auth: true },
    component: () => import('../pages/sales-entry/List.vue')
  },
  {
    path: 'sales-entry',
    name: prop + '.sales_entry',
    meta: { auth: true },
    component: () => import('../pages/sales-entry/Form.vue')
  },
  {
    path: 'stock-report',
    name: prop + '.stock_report',
    meta: { auth: true },
    component: () => import('../pages/stock-report/List.vue')
  },
  {
    path: 'return-product',
    name: prop + 'return_product',
    meta: { auth: true },
    component: () => import('../pages/return-product/List.vue')
  }
]
const routes = [{
  path: '/production-service/sales-center',
  name: 'production_service.sales_center',
  component: () => import('@/layouts/ProductionLayout.vue'),
  meta: { auth: true },
  children: childRoutes('production_service.sales_center')
}]

export default routes
